import React, { useContext, useState } from "react";

import { UiToast } from "@ask-christee/ui-response";

import { SubscriptionCard } from "../../molecules";
import { AddZipCodesModal } from "../AddZipCodesModal";
import {
  AccountDataProviderContext,
  CurrentUserProviderContext,
} from "../../../contexts";
import { UPGRADE_SUBSCRIPTION } from "../../../config";
import { AddStatesModal } from "../AddStatesModal";
import { UpdatePaymentMethodModal } from "../PaymentMethod/UpdatePaymentMethodModal";

export const SubscriptionToUpgrade = ({ subscriptionStatus, ...props }) => {
  const { currentUser, loadCurrentUser } = useContext(
    CurrentUserProviderContext,
  );
  const { accountData, setIsDataFetched, isDataFetched, updateAccountData } =
    useContext(AccountDataProviderContext);

  const [showUpgradeModal, setShowUpgradeModal] = useState(false);
  const [showPaymentMethodModal, setPaymentMethodModal] = useState(false);

  const onSuccessSubmit = async () => {
    setIsDataFetched((prevState) => ({
      ...prevState,
      nextInvoiceFetched: false,
      billingHistoryFetched: false,
      subscriptionItemsFetched: false,
      subscriptionLatestEndDate: false,
    }));

    await loadCurrentUser();

    UiToast.success("Your subscription has been successfully upgraded!");
  };

  const initiateUpgrade = () => {
    if (isDataFetched?.paymentDataFetched && !accountData?.paymentData)
      setPaymentMethodModal(true);
    else setShowUpgradeModal(true);
  };

  return (
    <>
      <SubscriptionCard
        disabled={
          subscriptionStatus !== "active" && subscriptionStatus !== "trialing"
        }
        buttonText={
          subscriptionStatus === "pending downgrade" ? "Pending" : "Upgrade"
        }
        buttonVariant="primary"
        onButtonClick={initiateUpgrade}
        {...props}
      />

      {currentUser.accountType === "agent" && (
        <AddZipCodesModal
          maxItems={1}
          title="Upgrade"
          submitMethod="PATCH"
          showModal={showUpgradeModal}
          isSubsequentPrice={false}
          submitUrl={UPGRADE_SUBSCRIPTION}
          onSuccessSubmit={onSuccessSubmit}
          handleCloseModal={() => setShowUpgradeModal(false)}
          text="You are upgrading to our Premium plan, unlocking new capabilities. Choose ZIP code and start utilizing your subscription to the fullest."
        />
      )}

      {currentUser.accountType === "loan officer" && (
        <AddStatesModal
          title="Upgrade"
          maxItems={1}
          submitMethod="PATCH"
          showModal={showUpgradeModal}
          submitUrl={UPGRADE_SUBSCRIPTION}
          onSuccessSubmit={onSuccessSubmit}
          handleCloseModal={() => setShowUpgradeModal(false)}
          text="You are upgrading to our Premium plan, unlocking new capabilities. Choose State and start utilizing your subscription to the fullest."
        />
      )}

      <UpdatePaymentMethodModal
        title="Add Payment Method"
        show={showPaymentMethodModal}
        updatePaymentData={(newPaymentData) => {
          updateAccountData({ paymentData: newPaymentData });
          setShowUpgradeModal(true);
        }}
        handleClose={() => setPaymentMethodModal(false)}
      />
    </>
  );
};
